import { ComponentType } from 'react';

import { Calendar } from '@yandex-360/iconostasis/dist/icons/Calendar';
import { Camera } from '@yandex-360/iconostasis/dist/icons/Camera';
import { CameraOff } from '@yandex-360/iconostasis/dist/icons/CameraOff';
import { MicroOff } from '@yandex-360/iconostasis/dist/icons/MicroOff';
import { MicroOn } from '@yandex-360/iconostasis/dist/icons/MicroOn';
import { Success } from '@yandex-360/iconostasis/dist/icons/Success';
import { Warning } from '@yandex-360/iconostasis/dist/icons/Warning';

import { IconostasisImageBaseProps } from './types';

export const ICONOSTASIS_IMAGE_MAP = {
    calendar: Calendar,
    success: Success,
    microOn: MicroOn,
    microOff: MicroOff,
    camera: Camera,
    cameraOff: CameraOff,
    warning: Warning,
} as Record<string, ComponentType<IconostasisImageBaseProps>>;
